import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { IconCheckOutline, IconDuplicateOutline } from '@circlefin/euclid-icons/common';
import { TruncatedText } from '../../TruncatedText/TruncatedText.es.js';
import { useCopyToClipboardContext } from '../CopyToClipboard.Context/index.es.js';
import { CopyToClipboardTooltip } from '../CopyToClipboard.Tooltip/CopyToClipboard.Tooltip.es.js';

const CopyToClipboardInline = ()=>{
    const [{ label, locale, truncatedText, isCopied }, { handleCopyClick }] = useCopyToClipboardContext();
    return jsxs(Fragment, {
        children: [
            label && jsx("p", {
                className: "label",
                children: label
            }),
            jsx(CopyToClipboardTooltip, {
                children: jsxs("button", {
                    "aria-label": `${label ?? ''} ${locale.beforeCopy} ${truncatedText}`,
                    onClick: handleCopyClick,
                    type: "button",
                    children: [
                        jsx(TruncatedText, {
                            children: truncatedText
                        }),
                        jsx("span", {
                            className: "icon-contain",
                            children: isCopied ? jsx(IconCheckOutline, {
                                size: 20
                            }) : jsx(IconDuplicateOutline, {
                                size: 20
                            })
                        })
                    ]
                })
            })
        ]
    });
};
CopyToClipboardInline.displayName = 'CopyToClipboard.Inline';

export { CopyToClipboardInline, CopyToClipboardInline as default };
//# sourceMappingURL=CopyToClipboard.Inline.es.js.map
